import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './calendar.css';

import 'moment/locale/ko';
import 'moment/locale/ja';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-tw';
import 'moment/locale/ms';
import 'moment/locale/th';
import 'moment/locale/id';
import 'moment/locale/mn';
import 'moment/locale/ru';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(<App />);
